import {Injectable} from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import {Observable} from 'rxjs';
import {ApplicationService} from "../services/application.service";
import {CompanyDataMgmtService} from "../services/company-data-mgmt.service";

@Injectable({
  providedIn: 'root'
})
export class SanctionedCompanyGuard  {

  constructor(private companyDataMgmtService: CompanyDataMgmtService, private router: Router) {
  }


  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (this.companyDataMgmtService.checkIsSanctionedCompany()) {
      return true;
    } else {
      this.router.navigate(['']);
    }
    return false;

  }

}
